export default __webpack_public_path__ + "static/media/logo.37789f1b.png";